import { MMKV } from 'react-native-mmkv';
import { StateStorage } from 'zustand/middleware';
import { MMKVStoreKeyMap } from './mmkvStoreKeyMap';

export const mmkvEventStore = new MMKV({
  id: MMKVStoreKeyMap.eventStore,
});

export const eventZstore: StateStorage = {
  setItem(name: string, value: string) {
    return mmkvEventStore.set(name, value);
  },
  getItem(name: string) {
    const value = mmkvEventStore.getString(name);
    return value ?? null;
  },
  removeItem(name: string) {
    return mmkvEventStore.delete(name);
  },
};
